import config from '@/config';
import { useQuery } from 'react-query';

type SmartChargingBrand = {
  id: string;
  name: string;
  synonyms: string[] | null;
};

async function fetchSmartChargingBrands() {
  const url = new URL('/api/smart-charging/brands', config.apiBaseUrl);
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error('Failed to fetch smart charging brands');
  }

  const brands: SmartChargingBrand[] | null = await response.json();

  return brands || [];
}

export function useSmartChargingBrands() {
  return useQuery({
    queryKey: ['smart-charging-brands'],
    queryFn: fetchSmartChargingBrands,
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 10, // 10 minutes
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retry: 3,
  });
}
